import { supabase } from '@/core/database/supabase';
import { enforceSettingsPermission } from '@/modules/settings/permissions/enforceSettingsPermission';
import type { TemplateRecord } from '../../list/types/templates.types';

export const templatesNewService = {
  async createTemplate(data: Partial<TemplateRecord>) {
    await enforceSettingsPermission('settings.templates.manage');
    
    const { data: result, error } = await supabase
      .from('settings_templates')
      .insert({
        company_id: data.companyId,
        name: data.name,
        code: data.code,
        description: data.description,
        type: data.type,
        status: data.status,
        content: data.content || {},
        created_by: data.createdBy,
      })
      .select()
      .single();

    if (error) throw error;
    return result;
  }
};
